import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEn from './translationEn.json';
import translationFr from './translationFr.json';

const resources = {
  en: {
    translation: translationEn,
  },
  fr: {
    translation: translationFr,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
export const t = i18n.t;
